import gql from 'graphql-tag'

const SigninUser = gql`
  mutation SigninUser ($credentials: AuthProviderEmailInput!) {
     signinUser(credentials: $credentials) {
      user {
        id
        email
        role
      }
      token {
        id
      }
     }
   }
`

export { SigninUser }


// WEBPACK FOOTER //
// ./src/mutations/SigninUser.js